import script from "./ZerobuyList.vue?vue&type=script&setup=true&lang=js"
export * from "./ZerobuyList.vue?vue&type=script&setup=true&lang=js"

import "./ZerobuyList.vue?vue&type=style&index=0&id=22becc4d&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-22becc4d"]])

export default __exports__